<template>
  <div class="sk-spinner sk-spinner-wave">
      <div class="sk-rect1"></div>
      <div class="sk-rect2"></div>
      <div class="sk-rect3"></div>
      <div class="sk-rect4"></div>
      <div class="sk-rect5"></div>
  </div>
</template>
<script>
  export default
  {
    name: 'Loading'
  }
</script>

<style scoped>
  .sk-spinner{
    position: absolute;
    left: 50%;
    top:50%;
    z-index:999
  }
</style>



// WEBPACK FOOTER //
// src/common/components/extend/loading/index.vue